<template>
  <div>
    <template v-if="question.image == 0 && question.content == null">
      <template v-for="answer in question.answers">
        <b-row :key="answer.id">
          <b-col :cols=6 :md=3>
            <template v-if="editable">
              <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input>
            </template>
            <template v-else>
              <b-form-input :state="Boolean(response && response.answer != null && answer.text_answer != null && response.answer.toUpperCase() == answer.text_answer.toUpperCase())" :value="response && response.answer != null ? response.answer.toUpperCase() : ''" readonly></b-form-input>
            </template>
          </b-col>
          <template v-if="!editable">
            <b-col :cols=6 :md=3>
              <template v-if="response && response.answer != null && answer.text_answer != null && response.answer.toLowerCase() != answer.text_answer.toLowerCase()">
                <b-form-input :state="true" :value="answer.text_answer" readonly></b-form-input>
              </template>
            </b-col>
          </template>
        </b-row>
      </template>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionListeningAudio',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false
    }
  },
  methods: {
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
  }
}
</script>